<h1 mat-dialog-title>Event Detail</h1>
<div mat-dialog-content>
    <div class="fields">
        <div class="field">
            <span class="title">Date</span>
            <span class="value">{{ eventLog?.dateString | date: 'dd-MM-yyyy hh:mm' }}</span>
        </div>
        <div class="field">
            <span class="title">Type</span>
            <span class="value">{{ eventLog?.eventType }}</span>
        </div>
        <div class="field">
            <span class="title">Event</span>
            <span class="value">{{ eventLog?.eventMessage }}</span>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Close</button>
</div>
